module.exports = __webpack_public_path__ + "media/src/images/arrow__questionBack--v2-5abc6b62aec17bb1e5d8ba58aeccedb0.png";